import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export interface MediaItem {
  id: string;
  url: string;
  type: 'image' | 'video';
  title: string;
  tags: string[];
  createdAt: string;
  dimensions: {
    width: number;
    height: number;
  };
  fileSize: number;
}

export interface PostTemplate {
  id: string;
  name: string;
  content: string;
  hashtags: string[];
  mediaLayout: string;
  platforms: string[];
}

export interface ContentCalendarEvent {
  id: string;
  title: string;
  date: string;
  platform: string;
  type: string;
  status: 'draft' | 'scheduled' | 'published' | 'pending_approval';
  content: string;
  media?: MediaItem[];
}

export interface ApprovalRequest {
  id: string;
  postId: string;
  requestedBy: string;
  requestedAt: string;
  status: 'pending' | 'approved' | 'rejected';
  comments: {
    user: string;
    comment: string;
    timestamp: string;
  }[];
}

// Biblioteca de mídia simulada
export const getMediaLibrary = (): MediaItem[] => {
  return [
    {
      id: '1',
      url: 'https://example.com/image1.jpg',
      type: 'image',
      title: 'Apartamento Luxo',
      tags: ['apartamento', 'luxo', 'decoração'],
      createdAt: new Date().toISOString(),
      dimensions: { width: 1080, height: 1080 },
      fileSize: 2048576
    },
    // Adicione mais itens conforme necessário
  ];
};

// Templates de posts
export const getPostTemplates = (): PostTemplate[] => {
  return [
    {
      id: '1',
      name: 'Lançamento Imóvel',
      content: '🏠 Novo lançamento imperdível!\n\n[NOME_EMPREENDIMENTO]\n📍 [LOCALIZAÇÃO]\n💰 A partir de R$ [VALOR]\n\nDestaques:\n✨ [DESTAQUE_1]\n✨ [DESTAQUE_2]\n✨ [DESTAQUE_3]\n\nEntre em contato agora mesmo para mais informações! 📱',
      hashtags: ['#imoveis', '#lancamento', '#investimento'],
      mediaLayout: 'carousel',
      platforms: ['instagram', 'facebook']
    },
    // Adicione mais templates conforme necessário
  ];
};

// Calendário de conteúdo
export const getContentCalendar = (): ContentCalendarEvent[] => {
  const today = new Date();
  const events: ContentCalendarEvent[] = [];
  
  for (let i = -7; i < 14; i++) {
    const date = new Date();
    date.setDate(today.getDate() + i);
    
    if (Math.random() > 0.5) {
      events.push({
        id: `event-${i}`,
        title: `Post ${Math.abs(i)}`,
        date: date.toISOString(),
        platform: Math.random() > 0.5 ? 'instagram' : 'facebook',
        type: Math.random() > 0.5 ? 'imagem' : 'carrossel',
        status: i < 0 ? 'published' : 'scheduled',
        content: 'Conteúdo do post...'
      });
    }
  }
  
  return events;
};

// Sistema de aprovação
export const getApprovalRequests = (): ApprovalRequest[] => {
  return [
    {
      id: '1',
      postId: 'post-1',
      requestedBy: 'usuario@email.com',
      requestedAt: new Date().toISOString(),
      status: 'pending',
      comments: [
        {
          user: 'usuario@email.com',
          comment: 'Post para aprovação',
          timestamp: new Date().toISOString()
        }
      ]
    },
    // Adicione mais requisições conforme necessário
  ];
};

// Compressão de mídia simulada
export const compressMedia = async (file: File, platform: string): Promise<Blob> => {
  // Simulação de compressão
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(file);
    }, 1000);
  });
};

// Cache de métricas
const metricsCache = new Map<string, any>();

export const getCachedMetrics = (key: string): any => {
  return metricsCache.get(key);
};

export const setCachedMetrics = (key: string, data: any): void => {
  metricsCache.set(key, {
    data,
    timestamp: new Date().getTime()
  });
};
